package meineglasfaser.frontend.www.pages.portal.auth

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.api.routes.AuthRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.GlobalCustomerState
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun VerifyPage(ctx: PageContext) {
    var errorText by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(ctx.route) {
        val id = ctx.route.queryParams["id"]
        val token = ctx.route.queryParams["token"]
        if (id == null || token == null) {
            errorText = "Ungültiger Link!"
            return@LaunchedEffect
        }
        val body = AuthRoutes.RealmCustomerPortal.Verify.RequestBody(id, token)
        BackendApi.post(AuthRoutes.RealmCustomerPortal.Verify()) {
            withAuth()
            setJsonBody(body)
        }.fold(
            onSuccess = {
                GlobalCustomerState.value = CustomerState.Indeterminate
                Toasts.display(
                    Toast.success("Erfolgreich verifiziert")
                )
                ctx.router.navigateTo("/kundenportal/overview")
            },
            onFailure = {
                Toasts.display(
                    Toast.error("Verifizierung fehlgeschlagen oder bereits durchgeführt!")
                )
            }
        )
    }

    Div(attrs = { classes("auth-form")}) {
        H1(attrs = { classes("text-center") }) {
            Text("E-Mail Verifizierung")
        }
        P {
            Text(errorText ?: "Verifizierung wird durchgeführt, bitte warten...")
        }
    }
}
